import React from 'react';
import styled, { css } from 'styled-components';

import useWindowWidth from '@hooks/useWindowWidth';
import HamburgerNav from '../navigation/HamburgerNav';
import TopNav from '@components/navigation/TopNav';
import LeftNav from '@components/navigation/LeftNav';
import { LAYOUT_TYPE, LAYOUT_TYPE_VALUE } from '@typings/setting/layoutType';
import MiniHomeNav from '../navigation/MiniHomeNav/index';
import { IhomepageSetting } from '@typings/setting/homepageSetting.interface';
import BlogNav from '@components/navigation/BlogNav';
import MemoNav from '@components/navigation/MemoNav/MemoNav';
import { scrollbarHide } from '@styles/variants/scrollbar';
import GameUINav from '@components/navigation/GameUINav/GameUINav';
import GameUiHamburgerNav from '@components/navigation/GameUiHamburgerNav';

const NavMap = {
  [LAYOUT_TYPE.MEMO]: css`
    overflow-y: auto;
    align-self: flex-start;
    height: calc(90dvh - 40px);
    ${scrollbarHide}
  `,
  [LAYOUT_TYPE.BLOG]: css`
    position: sticky;
    top: 0;
    overflow-y: visible;
    align-self: flex-start;
    height: auto;
    min-height: fit-content;
    ${scrollbarHide}
  `,
  [LAYOUT_TYPE.MINIHOME]: css``,
  [LAYOUT_TYPE.THREEDAN]: css``,
  [LAYOUT_TYPE.LEFT]: css``,
  [LAYOUT_TYPE.GAMEUI]: css`
    position: relative;
  `,
};

const NavContainer = styled.div<{ layoutType: LAYOUT_TYPE_VALUE }>`
  grid-area: nav;
  z-index: 3;
  ${({ layoutType }) => NavMap[layoutType]}
`;

const drawNav = {
  [LAYOUT_TYPE.TOP]: <TopNav />,
  [LAYOUT_TYPE.LEFT]: <LeftNav />,
  [LAYOUT_TYPE.MINIHOME]: <MiniHomeNav />,
  [LAYOUT_TYPE.BLOG]: <BlogNav />,
  [LAYOUT_TYPE.MEMO]: <MemoNav />,
  [LAYOUT_TYPE.THREEDAN]: <LeftNav />,
  [LAYOUT_TYPE.GAMEUI]: <GameUINav />,
};

type Props = {
  layoutType: LAYOUT_TYPE_VALUE;
  homeSet?: IhomepageSetting | null;
  hidden?: boolean;
};

function NavWrapper({ layoutType, homeSet, hidden }: Props) {
  const isMobile = useWindowWidth() < 768;

  if (!isMobile) {
    return (
      <NavContainer
        layoutType={layoutType}
        style={hidden ? { display: 'none' } : undefined}
      >
        {drawNav[layoutType]}
      </NavContainer>
    );
  }

  if (hidden) return null;
  return layoutType === LAYOUT_TYPE.GAMEUI ? (
    <GameUiHamburgerNav />
  ) : (
    <HamburgerNav />
  );
}

export default React.memo(NavWrapper);
